import { REPORTING_INSIGHTS_COPILOT_GENERATION } from '../../constants/Tools';
/**
 * Converts a legacy Reporting Insights Copilot Generation action to a V2 compatible format
 * @param inAppActionLegacy The legacy action to convert
 * @returns The converted action in V2 format
 */
export const convertReportingInsightsCopilotGenerationAction = inAppActionLegacy => {
  try {
    return {
      name: REPORTING_INSIGHTS_COPILOT_GENERATION,
      arguments: {
        '@type': 'map',
        value: {
          insightsGenerationRequestString: {
            '@type': 'string',
            value: JSON.stringify({
              reportEgg: inAppActionLegacy.report,
              dataset: inAppActionLegacy.dataset
            })
          }
        }
      }
    };
  } catch (e) {
    throw new Error('Failed to convert Reporting Insights Copilot Generation action via JSON.stringify');
  }
};